import { DemoConfig } from "../model/DemoConfig";
import { DemoTemplatePreview } from "../model/DemoTemplatePreview";
import { fetchWithToken } from "./fetchWithToken";

const getBaseUrl = (customerId: string) => {
    let url;
    switch (process.env.NODE_ENV) {
        case 'production':
            url = `/api/customers/${customerId}/demo/config`;
            break;
        case 'development':
            url = `http://localhost:5000/api/customers/${customerId}/demo/config`;
            break;
        default:
            url = `/api/customers/${customerId}/demo/config`;
    }
    return url;
};

const getCourseUrlBaseUrl = (customerId: string) => {
    let url;
    switch (process.env.NODE_ENV) {
        case 'production':
            url = `/api/customers/${customerId}/demo/course`;
            break;
        case 'development':
            url = `http://localhost:5000/api/customers/${customerId}/demo/course`;
            break;
        default:
            url = `/api/customers/${customerId}/demo/course`;
    }
    return url;
};

export async function getDemoConfig(customerId: string): Promise<DemoConfig> {
    try {
        const response = await fetchWithToken(getBaseUrl(customerId), {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Error while loading demo config");
        }

        return await response.json();
    } catch (error) {
        throw new Error("Error while loading demo config");
    }
}

export async function updateDemoConfig(customerId: string, demoConfig: DemoConfig): Promise<Response> {
    try {
        const response = await fetchWithToken(getBaseUrl(customerId), {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                courseUrl: demoConfig.courseUrl,
                courseName: demoConfig.courseName,
                demoTemplateIds: demoConfig.demoTemplateIds
            }),
        });

        return response;
    } catch (error) {
        throw new Error("Error while updating demo config");
    }
}

export async function getDemoCourseUrl(customerId: string): Promise<string> {
    try {
        const response = await fetchWithToken(getCourseUrlBaseUrl(customerId), {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Error while loading course URL");
        }

        return await response.text();
    } catch (error) {
        throw new Error("Error while loading course URL");
    }
}

export async function getDemoTemplates(customerId: string) {
    try {
        const response = await fetchWithToken(getBaseUrl(customerId).replace('/config', '/templates'), {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Error while loading demo templates");
        }

        return response;
    } catch (error) {
        throw new Error("Error while loading demo templates");
    }
}

export async function getDemoTemplatesPreview(customerId: string): Promise<DemoTemplatePreview[]> {
    try {
        const response = await fetchWithToken(getBaseUrl(customerId).replace('/config', '/templates/preview'), {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Error while loading demo templates preview");
        }

        return await response.json();
    } catch (error) {
        throw new Error("Error while loading demo templates preview");
    }
}

